import { AuthenticationInfoType } from "../../utility/types";
import { ProjectTimeLineItem } from "../PublishProject/types";
import ProjectTimeLine from "./ProjectTimeLine";
import { ProjectTreeNode } from "./ProjectTreeUtil";
import UTCSwitch from "./UTCSwitch";

type ProjectDetailsProps = {
  auth: AuthenticationInfoType;
  currentProject: ProjectTreeNode | undefined;
  timeLine: ProjectTimeLineItem[];
  displayUTC: boolean;
  onClickUTC: (on: boolean) => void;
};

const ProjectDetails = ({ auth, currentProject, displayUTC, onClickUTC, timeLine }: ProjectDetailsProps) => {
  return (
    <div>
      <div className="project-detail-header">
        <UTCSwitch displayUTC={displayUTC} onClick={(on) => onClickUTC(on)}></UTCSwitch>
        <h3>
          {currentProject?.projectFolder}/{currentProject?.text}
        </h3>
      </div>
      <h3>
        projectStoreId: {currentProject?.projectStoreId}
      </h3>
      <h3>
        uniqueId: {currentProject?.uniqueId}
      </h3>
      <ProjectTimeLine auth={auth} displayUTC={displayUTC} timeLine={timeLine}></ProjectTimeLine>
    </div>
  );
};

export default ProjectDetails;
